export default {"src":"__ASTRO_ASSET_IMAGE__Bc6S86m7__","width":48,"height":50,"format":"svg"}